export const templates = {
  id: "assessments",
  config: "/assessments/",
  build: () => "/assessments/",
  children: [
    {
      id: "assessmentsItems",
      config: "/assessments/items/",
      build: () => "/assessments/items/",
      children: [
        {
          id: "assessmentsOverview",
          config: "/assessments/items/:optional?",
          build: (optional) => {
            if (["overview", "statistics"].indexOf(optional) === -1) optional = ""

            return `/assessments/items/${optional}`
          },
        },
      ],
    },
    {
      id: "createNewAssessment",
      config: "/assessments/createNew",
      build: () => "/assessments/createNew",
    },
    {
      id: "assessment",
      config: "/assessments/item/:assessmentId/editor",
      build: (id) => `/assessments/item/${id}/editor/overview`,
      children: [
        {
          id: "assessmentEditor",
          config: "/assessments/item/:assessmentId/editor/:tab",
          build: (id, tab) => {
            if (["overview", "options", "questions", "forms"].indexOf(tab) === -1) tab = "overview"
            return `/assessments/item/${id}/editor/${tab}`
          },
        },
        {
          id: "assessmentFormEditor",
          config: "/assessments/item/:assessmentId/form-editor/:formId/:tab",
          build: (assessmentId, formId, tab) => {
            if (["pages", "questions", "scale"].indexOf(tab) === -1) tab = "pages"
            return `/assessments/item/${assessmentId}/form-editor/${formId}/${tab}`
          },
        },
        {
          id: "assessmentRevisionsHistory",
          config: "/assessments/item/:assessmentId/editorRevision/history",
          build: (id) => `/assessments/item/${id}/editorRevision/history`,
          children: [
            {
              id: "assessmentRevisionPreview",
              config: "/assessments/item/:assessmentId/editorRevision/history/:revisionId/preview",
              build: (id, revisionId) => `/assessments/item/${id}/editorRevision/history/${revisionId}/preview`,
            },
          ],
        },
        {
          id: "assessmentEditorPreview",
          config: "/assessments/item/:assessmentId/editor/editorPreview/:revisionId",
          build: (id, revisionId) => `/assessments/item/${id}/editor/editorPreview/${revisionId}`,
        },
        {
          id: "assessmentFormPreview",
          config: "/assessments/item/:assessmentId/editor/formPreview/:formId",
          build: (id, formId) => `/assessments/item/${id}/editor/formPreview/${formId}`,
        },
        {
          id: "assessmentForm",
          config: "/assessments/item/:assessmentId/editor/forms/:formId",
          build: (assessmentId, formId) => `/assessments/item/${assessmentId}/editor/forms/${formId}`,
          children: [
            {
              id: "assessmentQuestions",
              config: "/assessments/item/:assessmentId/editor/forms/:formId/questions",
              build: (assessmentId, formId) =>
                `/assessments/item/${assessmentId}/editor/forms/${formId}/questions`,
            },
            {
              id: "assessmentFormOptions",
              config: "/assessments/item/:assessmentId/editor/forms/:formId/options",
              build: (assessmentId, formId) =>
                `/assessments/item/${assessmentId}/editor/forms/${formId}/options`,
            },
          ],
        },
        {
          id: "assessmentSection",
          config: "/assessments/item/:assessmentId/editor/forms/:formId/sections/:assessmentSectionId",
          build: (assessmentId, formId, assessmentSectionId) =>
            `/assessments/item/${assessmentId}/editor/forms/${formId}/sections/${assessmentSectionId}`,
        },
      ],
    },
    {
      id: "assessmentPreview",
      config: "/assessments/preview/item/:id",
      build: (id) => `/assessments/preview/item/${id}`,
    },
    {
      id: "assessmentVersionsStatistics",
      config: "/assessments/statistics/:assessmentId",
      build: (assessmentId) => `/assessments/statistics/${assessmentId}`,
    },
    {
      id: "assessmentFormsStatistics",
      config: "/assessments/statistics/:assessmentId/:versionId/forms",
      build: (assessmentId, versionId) =>
        `/assessments/statistics/${assessmentId}/${versionId}/forms`,
    },
    {
      id: "assessmentQuestionsStatistics",
      config: "/assessments/statistics/:assessmentId/:versionId/:formId/questions",
      build: (assessmentId, versionId, formId) =>
        `/assessments/statistics/${assessmentId}/${versionId}/${formId}/questions`,
    },
  ],
}
